const allContainers = document.querySelectorAll('.estimated-runtime');
if (allContainers.length > 0) {
  const products = [
    {
      "name": "la1800w",
      "type": "lead-acid",
      "battery_ah": 60,
      "voltage_per_cell": 1.6,
      "efficiency": 0.95,
      "self_consumption_threshold": 10,
      "self_consumption_formula": {
        "k": 720 * 60,
        "a": 10,
        "b": 10
      },
      "max_input": 1800,
      "cell_num": 6,
      "data": [
        { "time_minutes": 10, "cell": 209.3, "power_min": 1255.8, "power_max": 1800 },
        { "time_minutes": 15, "cell": 172.1, "power_min": 1032.6, "power_max": 1255.8 },
        { "time_minutes": 20, "cell": 148, "power_min": 888, "power_max": 1032.6 },
        { "time_minutes": 30, "cell": 116.2, "power_min": 697.2, "power_max": 888 },
        { "time_minutes": 45, "cell": 87.6, "power_min": 525.6, "power_max": 697.2 },
        { "time_minutes": 60, "cell": 70.7, "power_min": 424.2, "power_max": 525.6 },
        { "time_minutes": 120, "cell": 38.9, "power_min": 233.4, "power_max": 424.2 },
        { "time_minutes": 180, "cell": 29.4, "power_min": 176.4, "power_max": 233.4 },
        { "time_minutes": 240, "cell": 23.9, "power_min": 143.4, "power_max": 176.4 },
        { "time_minutes": 300, "cell": 20.1, "power_min": 120.6, "power_max": 143.4 },
        { "time_minutes": 360, "cell": 17.7, "power_min": 106.2, "power_max": 116.2 },
        { "time_minutes": 480, "cell": 14.2, "power_min": 85.2, "power_max": 106.2 },
        { "time_minutes": 600, "cell": 12, "power_min": 72, "power_max": 85.2 },
        { "time_minutes": 1200, "cell": 6.41, "power_min": 11, "power_max": 72 }
      ]
    },
    {
      "name": "la1800w2",
      "type": "lead-acid",
      "battery_ah": 60,
      "voltage_per_cell": 1.6,
      "efficiency": 0.95,
      "self_consumption_threshold": 20,
      "self_consumption_formula": {
        "k": 1200 * 60,
        "a": 10,
        "b": 10
      },
      "max_input": 1800,
      "cell_num": 6,
      "data": [
        { "time_minutes": 10,  "cell": 523.4, "power_min": 3140.4, "power_max": 3600   },
        { "time_minutes": 15,  "cell": 430.1, "power_min": 2580.6, "power_max": 3140.4 },
        { "time_minutes": 20,  "cell": 369.9, "power_min": 2219.4, "power_max": 2580.6 },
        { "time_minutes": 30,  "cell": 290.4, "power_min": 1801, "power_max": 2219.4 },
        { "time_minutes": 45,  "cell": 219.0, "power_min": 1314.0, "power_max": 1800 },
        { "time_minutes": 60,  "cell": 176.7, "power_min": 1060.2, "power_max": 1314.0 },
        { "time_minutes": 120, "cell": 97.3,  "power_min": 583.8,  "power_max": 1060.2 },
        { "time_minutes": 180, "cell": 73.4,  "power_min": 440.4,  "power_max": 583.8  },
        { "time_minutes": 240, "cell": 59.7,  "power_min": 358.2,  "power_max": 440.4  },
        { "time_minutes": 300, "cell": 50.3,  "power_min": 301.8,  "power_max": 358.2  },
        { "time_minutes": 360, "cell": 44.2,  "power_min": 265.2,  "power_max": 301.8  },
        { "time_minutes": 480, "cell": 35.4,  "power_min": 212.4,  "power_max": 265.2  },
        { "time_minutes": 600, "cell": 29.9,  "power_min": 179.4,  "power_max": 212.4  },
        { "time_minutes": 1200,"cell": 16.0,  "power_min": 20,     "power_max": 179.4  }
      ]
    },
    {
      "name": "la3600w",
      "type": "lead-acid",
      "battery_ah": 100,
      "voltage_per_cell": 1.8,
      "efficiency": 0.95,
      "self_consumption_threshold": 20,
      "self_consumption_formula": {
        "k": 720 * 60,
        "a": 9,
        "b": 10
      },
      "max_input": 3600,
      "cell_num": 6,
      "data": [
        { "time_minutes": 10,  "cell": 348.9, "power_min": 2093.4, "power_max": 3600   },
        { "time_minutes": 15,  "cell": 286.8, "power_min": 1720.8, "power_max": 2093.4 },
        { "time_minutes": 20,  "cell": 246.6, "power_min": 1479.6, "power_max": 1720.8 },
        { "time_minutes": 30,  "cell": 193.6, "power_min": 1161.6, "power_max": 1479.6 },
        { "time_minutes": 45,  "cell": 146.0, "power_min": 876.0,  "power_max": 1161.6 },
        { "time_minutes": 60,  "cell": 117.8, "power_min": 706.8,  "power_max": 876.0  },
        { "time_minutes": 120, "cell": 64.8,  "power_min": 388.8,  "power_max": 706.8  },
        { "time_minutes": 180, "cell": 49.0,  "power_min": 294.0,  "power_max": 388.8  },
        { "time_minutes": 240, "cell": 39.8,  "power_min": 238.8,  "power_max": 294.0  },
        { "time_minutes": 300, "cell": 33.5,  "power_min": 201.0,  "power_max": 238.8  },
        { "time_minutes": 360, "cell": 29.4,  "power_min": 176.4,  "power_max": 201.0  },
        { "time_minutes": 480, "cell": 23.6,  "power_min": 141.6,  "power_max": 176.4  },
        { "time_minutes": 600, "cell": 20.0,  "power_min": 120.0,  "power_max": 141.6  },
        { "time_minutes": 1200,"cell": 10.7,  "power_min": 20,     "power_max": 120.0  }
      ]
    },
    {
      "name": "la3600w2",
      "type": "lead-acid",
      "battery_ah": 100,
      "voltage_per_cell": 1.8,
      "efficiency": 0.95,
      "self_consumption_threshold": 24,
      "self_consumption_formula": {
        "k": 1200 * 60,
        "a": 9,
        "b": 10
      },
      "max_input": 3600,
      "cell_num": 6,
      "data": [
        { "time_minutes": 10,  "cell": 683.9, "power_min": 4103.4, "power_max": 4200   },
        { "time_minutes": 15,  "cell": 596.8, "power_min": 3580.8, "power_max": 3600 },
        { "time_minutes": 20,  "cell": 467.0, "power_min": 2802.0, "power_max": 3580.8 },
        { "time_minutes": 30,  "cell": 337.2, "power_min": 2023.2, "power_max": 2802.0 },
        { "time_minutes": 45,  "cell": 252.1, "power_min": 1512.6, "power_max": 2023.2 },
        { "time_minutes": 60,  "cell": 218.6, "power_min": 1311.6, "power_max": 1512.6 },
        { "time_minutes": 120, "cell": 126.6, "power_min": 759.6,  "power_max": 1311.6 },
        { "time_minutes": 180, "cell": 98.0,  "power_min": 588.0,  "power_max": 759.6  },
        { "time_minutes": 240, "cell": 76.0,  "power_min": 456.0,  "power_max": 588.0  },
        { "time_minutes": 300, "cell": 65.2,  "power_min": 391.2,  "power_max": 456.0  },
        { "time_minutes": 360, "cell": 58.9,  "power_min": 353.4,  "power_max": 391.2  },
        { "time_minutes": 480, "cell": 44.6,  "power_min": 267.6,  "power_max": 353.4  },
        { "time_minutes": 600, "cell": 39.7,  "power_min": 238.2,  "power_max": 267.6  },
        { "time_minutes": 1200,"cell": 20.9,  "power_min": 24,     "power_max": 238.2  }
      ]
    },
    {
      "name": "la7200w",
      "type": "lead-acid",
      "battery_ah": 100,
      "voltage_per_cell": 1.8,
      "efficiency": 0.95,
      "self_consumption_threshold": 80,
      "self_consumption_formula": {
        "k": 720 * 60,
        "a": 10,
        "b": 50
      },
      "max_input": 7200,
      "cell_num": 12,
      "data": [
        { "time_minutes": 10,  "cell": 683.9, "power_min": 8206.8, "power_max": 9000   },
        { "time_minutes": 15,  "cell": 596.8, "power_min": 7161.6, "power_max": 7200 },
        { "time_minutes": 20,  "cell": 467.0, "power_min": 5604.0, "power_max": 7161.6 },
        { "time_minutes": 30,  "cell": 337.2, "power_min": 4046.4, "power_max": 5604.0 },
        { "time_minutes": 45,  "cell": 252.1, "power_min": 3025.2, "power_max": 4046.4 },
        { "time_minutes": 60,  "cell": 218.6, "power_min": 2623.2, "power_max": 3025.2 },
        { "time_minutes": 120, "cell": 126.6, "power_min": 1519.2, "power_max": 2623.2 },
        { "time_minutes": 180, "cell": 98.0,  "power_min": 1176.0, "power_max": 1519.2 },
        { "time_minutes": 240, "cell": 76.0,  "power_min": 912.0,  "power_max": 1176.0 },
        { "time_minutes": 300, "cell": 65.2,  "power_min": 782.4,  "power_max": 912.0  },
        { "time_minutes": 360, "cell": 55.1,  "power_min": 661.2,  "power_max": 782.4  },
        { "time_minutes": 480, "cell": 42.5,  "power_min": 510.0,  "power_max": 661.2  },
        { "time_minutes": 600, "cell": 38.0,  "power_min": 456.0,  "power_max": 510.0  },
        { "time_minutes": 1200,"cell": 20.2,  "power_min": 80,     "power_max": 456.0  }
      ]
    },
    {
      "name": "la7200w2",
      "type": "lead-acid",
      "battery_ah": 100,
      "voltage_per_cell": 1.8,
      "efficiency": 0.95,
      "self_consumption_threshold": 100,
      "self_consumption_formula": {
        "k": 1200 * 60,
        "a": 10,
        "b": 50
      },
      "max_input": 7200,
      "cell_num": 24,
      "data": [
        { "time_minutes": 10,  "cell": 683.9, "power_min": 16413.6, "power_max": 18000   },
        { "time_minutes": 15,  "cell": 596.8, "power_min": 14323.2, "power_max": 16413.6 },
        { "time_minutes": 20,  "cell": 467.0, "power_min": 11208.0, "power_max": 14323.2 },
        { "time_minutes": 30,  "cell": 337.2, "power_min": 8092.8,  "power_max": 11208.0 },
        { "time_minutes": 45,  "cell": 252.1, "power_min": 6050.4,  "power_max": 7200  },
        { "time_minutes": 60,  "cell": 218.6, "power_min": 5246.4,  "power_max": 6050.4  },
        { "time_minutes": 120, "cell": 126.6, "power_min": 3038.4,  "power_max": 5246.4  },
        { "time_minutes": 180, "cell": 98.0,  "power_min": 2352.0,  "power_max": 3038.4  },
        { "time_minutes": 240, "cell": 76.0,  "power_min": 1824.0,  "power_max": 2352.0  },
        { "time_minutes": 300, "cell": 65.2,  "power_min": 1564.8,  "power_max": 1824.0  },
        { "time_minutes": 360, "cell": 55.1,  "power_min": 1322.4,  "power_max": 1564.8  },
        { "time_minutes": 480, "cell": 42.5,  "power_min": 1020.0,  "power_max": 1322.4  },
        { "time_minutes": 600, "cell": 38.0,  "power_min": 912.0,   "power_max": 1020.0  },
        { "time_minutes": 1200,"cell": 20.2,  "power_min": 100,     "power_max": 912.0   }
      ]
    },

    { "name": "li1800", "type": "lithium", "capacity": 1440, "max_input": 1800, "lithium_offset": 30 },
    { "name": "li3600", "type": "lithium", "capacity": 3072, "max_input": 3600, "lithium_offset": 30 },
    { "name": "li6000", "type": "lithium", "capacity": 3840, "max_input": 6000, "lithium_offset": 40 },
    { "name": "mygrid10k", "type": "lithium", "capacity": 10496, "max_input": 10000, "lithium_offset": 50 },
    { "name": "mygrid15k", "type": "lithium", "capacity": 10496, "max_input": 15000, "lithium_offset": 50 }
  ];

  allContainers.forEach(container => {
    const maxDevices = parseInt(container.dataset.devicesMax) || 5;
    const addButton = container.querySelector('.add-device');
    const calcButton = container.querySelector('.calc-btn');
    const resultElement = container.querySelector('.res-time');
    const calcError = container.querySelector('.calc-error');

    let deviceCount = 1;

    function updateAddButtonVisibility() {
      if (addButton) {
        addButton.style.display = (deviceCount < maxDevices) ? '' : 'none';
      }
    }

    updateAddButtonVisibility();

    container.addEventListener('click', (e) => {
      if (e.target.closest('.add-device')) {
        e.preventDefault();

        if (deviceCount >= maxDevices) {
          updateAddButtonVisibility();
          return;
        }

        deviceCount++;

        const newDevice = document.createElement('div');
        newDevice.className = 'device';
        newDevice.innerHTML = `
          <span>Device ${deviceCount}: </span>
          <div class="field">
            <input class="field__input" type="text" value="">
            <label class="field__label">W</label>
          </div>
          <button class="button button--secondary btn-del"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /></svg><span class="txt">Delete</span></button>
        `;

        const deviceList = container.querySelector('.device-list');
        if (deviceList) {
          deviceList.appendChild(newDevice);
        }

        bindInputEvents();
        updateAddButtonVisibility();
      }
      if (e.target.closest('.calc-btn')) {
        updateRuntimeResult(container);
      }
      if(e.target.closest('.btn-del')){
        e.preventDefault();
        e.target.closest('.device').remove();
        calcButton.click();
      }
    });

    function bindInputEvents() {
      const inputs = container.querySelectorAll('.field__input');
      inputs.forEach(input => {
        if (!input.hasAttribute('data-bound')) {
          input.setAttribute('data-bound', 'true');
          input.addEventListener('input', handleInputChange);
        }
      });
    }

    function handleInputChange(e) {
      const input = e.target;
      let value = input.value;
      value = value.replace(/[^\d.]/g, '');
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts[1];
      }
      if (value.startsWith('.')) {
        value = '0' + value;
      }
      input.value = value;
    }

    function getCurrentPowerConfig() {
      const candidates = document.querySelectorAll('[data-product-type]');

      for (const el of candidates) {
        let isSelected = false;

        if (el.tagName === 'INPUT') {
          if ((el.type === 'radio' || el.type === 'checkbox') && el.checked) {
            isSelected = true;
          }
        } else if (el.tagName === 'OPTION') {
          if (el.selected) {
            isSelected = true;
          }
        } else {
          if (
            el.classList.contains('active') ||
            el.getAttribute('aria-selected') === 'true'
          ) {
            isSelected = true;
          }
        }

        if (isSelected) {
          const productType = el.dataset.productType;
          const maxPower = parseFloat(el.dataset.maxPower) || null;
          const remainingCapacity = parseFloat(el.dataset.remainingCapacity) || null;

          return {
            productType,
            maxPower: isNaN(maxPower) ? null : maxPower,
            remainingCapacity: isNaN(remainingCapacity) ? null : remainingCapacity,
            element: el
          };
        }
      }

      return null;
    }

    function updateRuntimeResult(container) {

      const config = getCurrentPowerConfig();

      const inputs = container.querySelectorAll('.field__input');
      let totalPower = 0;

      inputs.forEach(input => {
        const val = parseFloat(input.value);
        if (!isNaN(val) && val > 0) {
          totalPower += val;
        }
      });

      if (totalPower <= 0) {
        resultElement.innerHTML = '<span class="res-number">00</span> hrs';
        calcError.innerHTML = '';
        return;
      }

      const result = calculateRuntime(totalPower, config);
      if (result.error) {
        calcError.innerHTML = result.error;
        resultElement.innerHTML = '<span class="res-number">00</span> hrs';
      } else {
        calcError.innerHTML = '';
        const hours = result.runtimeMinutes / 60;
        const roundedHours = Math.round(hours * 100) / 100;
        resultElement.innerHTML = `<span class="res-number"> ${roundedHours}</span> hrs`;
      }
    }

    function calculateRuntime(powerW, config) {
      const product = products.find(p => p.name === config.productType);
      if (!product) return { error: `Product not found: ${config.productType}` };

      const effectiveMaxInput = config.maxPower || product.max_input;
      if (typeof effectiveMaxInput === 'number' && powerW > effectiveMaxInput) {
        return { error: `Input power cannot exceed ${effectiveMaxInput}W.` };
      }

      let runtimeMinutes;

      if (product.type === "lithium") {
        const whCapacity = config.remainingCapacity || product.capacity;
        const offset = product.lithium_offset;
        if (whCapacity <= 0) return { error: "Invalid battery capacity." };
        const hours = whCapacity / (powerW / 0.9 + offset);
        runtimeMinutes = hours * 60;
      } else {
        const data = product.data;
        let matched = false;

        for (const row of data) {
          if (powerW >= row.power_min && powerW <= row.power_max) {
            const k = row.time_minutes * row.cell * product.cell_num;
            runtimeMinutes = k / powerW;
            console.log(`k=${4},time_minutes=${row.time_minutes},cell=${row.cell},cell_num=${product.cell_num}`);
            matched = true;
            break;
          }
        }

        if (!matched) {
          if (powerW <= product.self_consumption_threshold) {
            const { k, a, b } = product.self_consumption_formula;
            runtimeMinutes = k / (a + powerW / b);
          } else {
            return { error: `Input power cannot exceed ${powerW}W.` };
          }
        }
      }

      return {
        product: config.productType,
        inputPowerW: powerW,
        runtimeMinutes: parseFloat(runtimeMinutes.toFixed(8))
      };
    }

    bindInputEvents();
  });
}